export default class BrandDomainService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('brand/domains', params)
	}

	createEntity(params){
		return this.apiService.callPost('brand/domains', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('brand/domains/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('brand/domains/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BrandDomainService.js